<template>
  <div class="page">
    <div class="title">实名认证</div>
    <el-divider></el-divider>
    <div class="container">
      <div><span>请选择认证类型</span></div>
      <div class="types">
        <div class="logo">
          <img src="../../assets/img/qiye.png"
               alt="" />
        </div>
        <div class="typeRight"
             @click="fileVisible = true,type=1">
          <div>
            <div class="typesTitle">企业认证</div>
            <div class="summary">
              <p>适用于企业、个体工商户、事业单位等。</p>
              <p>如果你需要购买保险必须认证企业。</p>
            </div>
          </div>
          <div>
            <i style="font-size: 30px"
               class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
      <!-- <div class="types"
           v-if="!$store.state.isPersonage">
        <div class="logo">
          <img src="../../assets/img/personal.png"
               alt=""
               style="border-radius:0;width:80px;" />
        </div>
        <div class="typeRight"
             @click="fileVisible = true,type=2">
          <div>
            <div class="typesTitle">个人认证</div>
            <div class="summary">
              <p>适用于个人的身份认证。</p>
              <p></p>
            </div>
          </div>
          <div>
            <i style="font-size: 30px"
               class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div> -->
      <el-dialog title="提示"
                 :visible.sync="fileVisible"
                 :close-on-click-modal="false"
                 :close-on-press-escape="false"
                 width="440px"
                 center>
        <div style="display: flex; justify-content: center">
          <el-button size="mini"
                     type="primary"
                     @click="openDialog"
                     style="margin-left: 15px">手机认证</el-button>
          <el-button size="mini"
                     type="success"
                     @click="$router.push(type==1 ? '/certifiForm' :'/personalForm')">pc端认证</el-button>
        </div>
        <span slot="footer"
              class="dialog-footer">
          <el-button size="small "
                     :loading="submitLoading"
                     @click="fileVisible = false">关 闭</el-button>
        </span>
      </el-dialog>
      <el-dialog title="手机认证"
                 :visible.sync="QRVisible"
                 :close-on-click-modal="false"
                 :close-on-press-escape="false"
                 width="400px"
                 center
                 @close="closeDialog">
        <div style="display: flex; justify-content: center">
          <img :src="imgPath"
               alt=""
               v-if="$shareType == 2" />
          <div id="qrcode"
               ref="qrcode"
               v-if="$shareType == 1"></div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>


<script>
import { GetUnlimitedQRCodeMinix } from "@/utils/mixin";
export default {
  mixins: [GetUnlimitedQRCodeMinix],
  data () {
    return {
      fileVisible: false,
      submitLoading: false,
      QRVisible: false,
      imgPath: "",
      type: 0
    };
  },
  methods: {
    closeDialog () {
      document.getElementById("qrcode").innerHTML = "";
    },
    qrcode () {
      if (this.$shareType == 1) {
        console.log(
          baseUrl.website +
          "/#/pages/packageC/home/recordPerson?cid=" +
          this.$store.state.id +
          "&companyName=" +
          this.$store.state.companyName +
          "&userName=" +
          JSON.parse(localStorage.getItem("userInfo")).cname
        );
        let qrcode = new QRCode("qrcode", {
          width: 300, // 设置宽度，单位像素
          height: 300, // 设置高度，单位像素
          text:
            baseUrl.website +
            "/#/pages/packageC/home/recordPerson?cid=" +
            this.$store.state.id +
            "&companyName=" +
            this.$store.state.companyName +
            "&userName=" +
            JSON.parse(localStorage.getItem("userInfo")).cname,
          // 设置二维码内容或跳转地址
        });
      }
      if (this.$shareType == 2) {
        this.submitLoading = true;
        let sendData = {
          page: this.type == 1 ? "pages/packageC/home/authentication" : "pages/packageC/home/personalAuthentication",
          check_path: false,
          width: 150,
          scene: JSON.parse(localStorage.getItem("CompanyDetail")).autoIntId,
        };
        this.GetUnlimitedQRCode(sendData).then((res) => {
          this.imgPath = "data:image/png;base64," + res;
          this.submitLoading = false;
          this.QRVisible = true;
        });
      }
    },
    // 打开并生成二维码
    openDialog () {
      if (this.$shareType == 1) {
        this.QRVisible = true;
      }
      this.$nextTick(() => {
        this.qrcode();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.page {
  .title {
    text-align: center;
    font-size: 23px;
  }
  .container {
    padding: 0 15px;
    .types {
      width: 100%;
      height: 200px;
      border: 1px solid #dcdfe6;
      margin-top: 15px;
      display: flex;

      .logo {
        width: 200px;
        height: 200px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 100px;
          border-radius: 50%;
        }
      }
      .typeRight {
        flex: 1;
        // padding-top: 60px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-right: 60px;
        cursor: pointer;
        .typesTitle {
          font-weight: 700;
          font-size: 18px;
        }
        .summary {
          margin-top: 20px;
          p {
            color: #909399;
            line-height: 26px;
          }
        }
      }
    }
  }
}
</style>